import React, { useState } from 'react';
import './MoneyInput.css';
import { transferMoney } from '../../../utils/FamilyApiService';
import CameraAuthentication from '../CameraAuthentication/CameraAuthentication';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Modal from 'react-modal';

const customStylesModal = {
  content: {
    top: '300px',
    width: '435px',
    height: '335px',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
    border: 'solid black 1px',
  },
  overlay: {
    transition: 'all 0.3s linear',
    backgroundColor: 'rgba(150, 150, 150, 0.8)'
  },
};

const MoneyInput = ({
  kidName,
  refreshTrigger
}) => {
  let input;

  const [loading, setLoading] = useState(false);
  const [moneyValue, setMoneyValue] = useState(0);
  const [transferSuccess, setTransferSuccess] = useState(null);
  const [transferResultMessage, setTransferResultMessage] = useState("");

  async function submitTransferMoney() {
    setTransferResultMessage("");
    setLoading(true);
    try {
      var result = await transferMoney(kidName, moneyValue, null);
      setTransferSuccess(result.success);
      setTransferResultMessage(result.transferResultMessage);
      refreshTrigger();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }

    // confirmAlert({
    //   customUI: ({ onClose }) => {
    //     return (
    //       <div className='cameraAuthenticationModal'>
    //         <CameraAuthentication onCompleteCountdown={async (param) => {
    //           setTransferResultMessage("");
    //           setLoading(true);
    //           onClose();
    //           var result = await transferMoney(kidName, moneyValue, param);
    //           setLoading(false);
    //           setTransferSuccess(result.success);
    //           setTransferResultMessage(result.transferResultMessage);
    //           refreshTrigger();
    //         }} />
    //       </div>
    //     );
    //   }
    // });
  };

  function addMoneyValue(addMoney) {
    var newMoneyValue = moneyValue + addMoney;
    setMoneyValue(newMoneyValue < 0 ? 0 : newMoneyValue);
  }

  return (
    <div className="moneyInputContainer">
      <Modal
        isOpen={loading}
        style={customStylesModal}
      >
        <img src="/images/fingerprint.gif" />
      </Modal>
      <div className="floatLeft moneyInputInfoLabel">Overfør penger til {kidName}</div>
      <div>
        <input
          className="moneyInput moneyInputNumber"
          ref={node => { input = node; }}
          type="number"
          min={0}
          onInput={() => setMoneyValue(parseInt(input.value) ? parseInt(input.value) : 0)}
          value={(moneyValue !== undefined) ? moneyValue : '0'} />
        <button className="moneyInput moneyInputLabel" disabled={true}>kr</button>
        <button className="moneyInput moneyInputButton buttonUOutline" id="moneyInputButtonDecrease" type="button" onClick={() => addMoneyValue(-1)}><span className="glyphicon"><i className="fas fa-minus"></i></span></button>
        <button className="moneyInput moneyInputButton buttonUOutline" id="moneyInputButtonIncrease" type="button" onClick={() => addMoneyValue(1)}><span className="glyphicon"><i className="fas fa-plus"></i></span></button>
        <button className="transferButton buttonUOutline transferMoneyButton" disabled={loading} onClick={async () => await submitTransferMoney(kidName, moneyValue)}><div className="buttonSpinner" style={{ display: loading ? 'block' : 'none' }}></div><div style={{ display: loading ? 'none' : 'block' }}>Overfør<span className="dollar"><i className="fas fa-money-bill-wave"></i></span></div></button>
        <div className={transferSuccess ? "transferSuccess" : "transferFail"}>{transferResultMessage}</div>
        <div className="addMoneyButtonContainer">
          <button className="addMoneyButton buttonUOutline" onClick={() => addMoneyValue(50)}>+50</button><button className="addMoneyButton buttonUOutline" onClick={() => addMoneyValue(100)}>+100</button><button className="addMoneyButton buttonUOutline" onClick={() => addMoneyValue(500)}>+500</button>
        </div>
      </div>
    </div>


  );
};

export default MoneyInput;
